import mock from './mock'

import './jwt'
import './apps/email'

mock.onAny().passThrough()
